var map = {
	"./Bundala.png": 312,
	"./GalwaysLand.png": 314,
	"./Hikkaduwa.png": 315,
	"./Horagolla.png": 316,
	"./HortonPlains.png": 317,
	"./Kaudulla.png": 318,
	"./Kumana.png": 326,
	"./Lahugala.png": 319,
	"./Lunugamvehera.png": 320,
	"./MaduruOya.png": 321,
	"./Minneriya.png": 322,
	"./Udawalawa.png": 323,
	"./Wasgamuwa.png": 324,
	"./Wilpattu.png": 325,
	"./flood-plains.jpg": 313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1625;